import { render, staticRenderFns } from "./PasswordModal.vue?vue&type=template&id=580acb25&scoped=true&"
import script from "./PasswordModal.vue?vue&type=script&lang=js&"
export * from "./PasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordModal.vue?vue&type=style&index=0&id=580acb25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580acb25",
  null
  
)

export default component.exports